module.exports = __webpack_public_path__ + "static/sell2-8c8e36a88eae70f4cb7046c63d6ac44d.jpg";